import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { AccountCircle } from '@material-ui/icons';
import { useDispatch } from 'react-redux';
import ENDPOINT from '../../context/EndPoint';
import SecurityHeaders from '../../context/SecurityHeaders';
import { useLocation } from 'react-router-dom';

const AddTeamMember = () => {
  const [profilePic, setProfilePic] = useState(null);
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [designation, setDesignation] = useState('');
  const [category, setCategory] = useState('');
  const [onlineStatus, setOnlineStatus] = useState('active');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const location = useLocation();
const queryParams = new URLSearchParams(location.search);
const editId = queryParams.get("id");
const isEdit = !!editId;
const [existingImage, setExistingImage] = useState(null);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.type.startsWith('image/')) {
        setProfilePic(file);
        setError(null);
      } else {
        setError('Please select a valid image file (e.g., JPEG, PNG).');
        setProfilePic(null);
      }
    }
  };

  const addTeamMember = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    dispatch({ type: 'LOADING' });

// Email validation only if entered
if (email && !email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
  setError('Please enter a valid email address.');
  setLoading(false);
  dispatch({ type: 'DONE_LOADING' });
  return;
}

// Phone validation only if entered
if (phone && !phone.match(/^\d{10,15}$/)) {
  setError('Please enter a valid phone number (10-15 digits).');
  setLoading(false);
  dispatch({ type: 'DONE_LOADING' });
  return;
}

    const data = new FormData();
    if (profilePic) {
      data.append('profile_pic', profilePic);
    }
    data.append('first_name', firstName);
    data.append('last_name', lastName);
    data.append('designation', designation);
    data.append('email', email ? email : '');
    data.append('phone', phone ? phone : '');
    data.append('category', category ? category : '');
    data.append('status', onlineStatus);

    try {
      const url = isEdit
      ? ENDPOINT + "edit-team-member.php"
      : ENDPOINT + "add-team-member.php";
    
    if (isEdit) {
      data.append("id", editId);
    }
    
    const res = await axios.post(url, data, SecurityHeaders);

      if (res?.data?.status === 'success') {
        dispatch({ type: 'DONE_LOADING' });
        window.location.replace('/team-members-all');
      } else {
        dispatch({
          type: 'ERROR',
          payload: res?.data?.message || 'Failed to add team member',
        });
        setError(res?.data?.message || 'Failed to add team member');
      }
    } catch (error) {
      dispatch({
        type: 'ERROR',
        payload: error.message || 'An error occurred while adding team member',
      });
      setError(error.message || 'An error occurred while adding team member');
    } finally {
      setLoading(false);
    }
  };

  const getMemberDetails = async () => {
    try {
      const formData = new FormData();
      formData.append("id", editId);
  
      const res = await axios.post(
        ENDPOINT + "get-single-team-member.php",
        formData,
        SecurityHeaders
      );
  
      if (res.data.status === "success") {
        const data = res.data.data;
  
        setFirstName(data.first_name);
        setLastName(data.last_name);
        setEmail(data.email || "");
        setPhone(data.phone || "");
        setDesignation(data.designation);
        setCategory(data.category || "");
        setOnlineStatus(data.status);
        setExistingImage(data.profile_pic);
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    if (isEdit) {
      getMemberDetails();
    }
  }, [editId]);

  return (
    <div className="container">
      <div className="container card col-11 col-lg-6 col-sm-12 col-md-10 p-4 shadow rounded-3">
        <h2 className="mb-3">Add Team Member</h2>
        {error && <div className="alert alert-danger">{error}</div>}
        {loading && <div className="text-center mb-3"><div className="spinner-border" role="status"><span className="visually-hidden">Loading...</span></div></div>}
        <form onSubmit={addTeamMember}>
          <div className="mb-3">
            <label htmlFor="profilePic" className="form-label">Profile Picture</label>
            <div>
              <div
                style={{
                  height: 90,
                  width: 90,
                  borderRadius: '50%',
                  overflow: 'hidden',
                  cursor: 'pointer',
                  display: 'inline-block',
                  backgroundColor: '#f0f0f0',
                  backgroundImage: profilePic
                  ? `url(${URL.createObjectURL(profilePic)})`
                  : existingImage
                  ? `url(${existingImage})`
                  : 'none',
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                }}
              >
                {!profilePic && !existingImage && (
  <AccountCircle style={{ height: '100%', width: '100%', color: '#ccc' }} />
)}
              </div>
              <input
                type="file"
                id="profilePic"
                accept="image/*"
                onChange={handleFileChange}
                className="form-control mt-2"
              />
            </div>
          </div>
          <div className="mb-3">
            <label htmlFor="firstName" className="form-label">First Name</label>
            <input
              type="text"
              className="form-control"
              id="firstName"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
              required
            />
          </div>
          <div className="mb-3">
            <label htmlFor="lastName" className="form-label">Last Name</label>
            <input
              type="text"
              className="form-control"
              id="lastName"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
              required
            />
          </div>
          <div className="mb-3">
            <label htmlFor="email" className="form-label">Email</label>
            <input
              type="email"
              className="form-control"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              
            />
          </div>
          <div className="mb-3">
            <label htmlFor="phone" className="form-label">Phone Number</label>
            <input
              type="text"
              className="form-control"
              id="phone"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              
            />
          </div>
          <div className="mb-3">
            <label htmlFor="designation" className="form-label">Designation</label>
            <input
              type="text"
              className="form-control"
              id="designation"
              value={designation}
              onChange={(e) => setDesignation(e.target.value)}
              required
            />
          </div>
          <div className="mb-3">
            <label htmlFor="category" className="form-label">Category</label>
            <input
              type="text"
              className="form-control"
              id="category"
              value={category}
              onChange={(e) => setCategory(e.target.value)}
              
            />
          </div>
          <div className="mb-3">
            <label htmlFor="onlineStatus" className="form-label">Online Status</label>
            <select
              className="form-control"
              id="onlineStatus"
              value={onlineStatus}
              onChange={(e) => setOnlineStatus(e.target.value)}
            >
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
            </select>
          </div>
          <button type="submit" className="btn btn-primary" disabled={loading}>
          {loading ? 'Saving...' : isEdit ? 'Update Member' : 'Add Team Member'}
          </button>
          <Link to="/team-members-all" className="btn btn-secondary ms-2">
            Cancel
          </Link>
        </form>
      </div>
    </div>
  );
};

export default AddTeamMember;